export const TRACKER_SHOW_NPS_BANNER = '[NPS Banner] show banner';
export const TRACKER_CANCEL_NPS_FEEDBACK = '[NPS Banner] cancel feedback';
export const TRACKER_NPS_BANNER_RATE = '[NPS Banner] rate';

export const NPS_BANNER_ILLUSTRATION = 'https://res.cloudinary.com/hevo/image/upload/v1661186305/dashboard/rating_mdj6ig.svg';
export const NPS_BANNER_ILLUSTRATION_DARK = 'https://res.cloudinary.com/hevo/image/upload/v1661186304/dashboard/rating-dark_bzvpz0.svg'
